import React from "react";
import { Box, Divider, Typography } from "@mui/material";

/**
 * Shared page heading: brand-blue title with a matching rule underneath.
 * Every list page uses this so the headings stay in sync instead of each
 * screen styling its own title.
 *
 * `action` renders on the right of the title row (e.g. a "New Profile" button).
 */
export default function PageHeading({ title, action }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          mb: 1,
        }}
      >
        <Typography
          variant="h5"
          component="h1"
          sx={{
            color: "primary.main",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {title}
        </Typography>

        {action}
      </Box>

      <Divider sx={{ borderBottomWidth: 2, borderColor: "primary.main" }} />
    </Box>
  );
}
